const L = /^[a-zA-Z]{2}(-[a-zA-Z]{2})?$/, G = 200, E = "EM_TAG_PLACEHOLDER", _ = "END_EM_TAG_PLACEHOLDER", R = new RegExp(`(${E}|${_})`), A = "ais-highlight-0000000000", H = "em", T = new RegExp(A, "g"), n = 5;
export {
  A as ALGOLIA_HIGHLIGHT_TAG,
  T as ALGOLIA_HIGHLIGHT_TAG_REGEXP,
  E as EM_TAG_PLACEHOLDER,
  _ as END_EM_TAG_PLACEHOLDER,
  L as LOCALE_REGEX,
  G as MAXIMUM_NUMBER_OF_RESULTS_PER_SECTION,
  n as MAX_NUMBER_OF_RESULTS,
  R as PLACEHOLDER_REGEX,
  H as SEARCH_BAR_HIGHLIGHT_TAG
};
//# sourceMappingURL=help-center-articles-search19.js.map
